import React from 'react';
import { ClearspaceImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P } from '@helpers';

export const LogoClearspace = ({t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='83px' marginLeft='101px' paddingBottom='67px'>
          <P weight='400' size='25px' height='30px'>{t("Logo clearspace")}</P>
          <FlexDiv>
            <Text width='308px' paddingBefforeText="45px">
            <p>
              {t("This requirement is intended to separate the logo from other graphic and text elements and to ensure better legibility. Logo clearspace is the minimum blank space that should separate the logo elements from any other media components. The set proportions of the blank space cannot be changed. If there are no other graphic elements adjacent to the logo, the Logo clearspace rule does not apply.")}
            </p>
            </Text>
            <Margin marginLeft='34px' marginRight='25px' marginTop='127px'>
              <ClearspaceImg/>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
